if (!customElements.get("byte-feature-tabs")) {
  class ByteFeatureTabs extends HTMLElement {
    constructor() {
      super();
      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.#cacheElements();
      this.#bindEvents();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const trigger = event.target.closest("[data-tab-trigger]");
      if (!trigger) return;
      this.#activateTab(trigger.dataset.tabTrigger);
    }

    #cacheElements() {
      this.triggers = Array.from(this.querySelectorAll("[data-tab-trigger]"));
      this.panels = Array.from(this.querySelectorAll("[data-tab-panel]"));
    }

    #bindEvents() {
      this.addEventListener("click", this.boundHandleClick);
    }

    #unbindEvents() {
      this.removeEventListener("click", this.boundHandleClick);
    }

    #activateTab(index) {
      for (const trigger of this.triggers) {
        const isActive = trigger.dataset.tabTrigger === index;
        trigger.classList.toggle("is-active", isActive);
        trigger.setAttribute("aria-selected", String(isActive));
      }
      for (const panel of this.panels) {
        panel.classList.toggle("is-active", panel.dataset.tabPanel === index);
      }
    }
  }

  customElements.define("byte-feature-tabs", ByteFeatureTabs);
}
